import { render, staticRenderFns } from "./report-work.vue?vue&type=template&id=242bee5e&scoped=true"
import script from "./report-work.vue?vue&type=script&lang=js"
export * from "./report-work.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242bee5e",
  null
  
)

export default component.exports